import React from 'react'
import Container from 'react-bootstrap/esm/Container';
import { Link } from 'react-router-dom'
import useUser from "../../hooks/useUser";
import MyNavbar from '../Home/MyNavbar/MyNavbar';
import Login from './Login';
import Reports from './Reports';
import {AiOutlineHome} from 'react-icons/ai';
import HeaderMiniso from '../Home/HeaderMiniso/HeaderMiniso';
import MyFooter from '../Home/MyFooter/MyFooter';
import RootUser from './RootUser';
import Consulta from './Consulta';

const Admin = () => {
  const [adminUser] = useUser();
  
  return (
    <div>
      <HeaderMiniso/>
      <MyNavbar section={'Section Admin'}/>
      {!adminUser.logged&&!adminUser.rootUser&&<Login/>}
      {adminUser.logged&&<Consulta/>}
      {adminUser.rootUser&& <RootUser/>}
      
      <Container className='w-100 d-flex justify-content-end'>
      <Link to='/' className='btn btn-secondary fs-5 mt-3'>{<AiOutlineHome/>||'Home'}</Link>
      </Container>
      <MyFooter/>
      
    </div>
  )
}

export default Admin